import { Asset, Attachment, Container } from '@integration-frontends/integration/core/model';

export const DOWNLOAD_SERVICE_TOKEN = 'DOWNLOAD_SERVICE';

export interface IDownloadService {
  getAssetDownloadLink(container: Container, asset: Asset): string;
  getAttachmentDownloadLink(container: Container, attachment: Attachment): string;
}
